export const Primary = {
    Black: 'black',
    White: 'white',
    Red: 'red',
    Green: '#01DC66',
    LightYellow: '#fff6dc',
}